import { render } from "./InvoiceCustomerNotes.vue?vue&type=template&id=4fa8758d&ts=true"
import script from "./InvoiceCustomerNotes.vue?vue&type=script&lang=ts"
export * from "./InvoiceCustomerNotes.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__